module.exports = __webpack_public_path__ + "media/images/bcloader-ec597722.gif";